import styled from "styled-components"

export const ModalWrap = styled.div`
  padding: 32px 0;
  position: relative;
`

export const Expand = styled.img`
  position: absolute;
  right: 4px;
  top: 36px;
  cursor: pointer;
  opacity: .7;
  z-index: 1;
  transition: ease 0.2s opacity;
  &:hover {
    opacity: 1;
  }
`